import { StyleSheet, Platform } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: {
    marginTop: Platform.OS === 'ios' ? 12 : 2,
  },
  cardContainerStyle: theme => ({
    paddingVertical: 18,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    marginBottom: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    ...cardShadow,
  }),
  cardContent: {
    flexDirection: 'row',
  },
  squareStyle: height => ({
    height,
    borderRadius: 6,
    width: 96,
  }),
  headerFirstLine: {
    height: 24,
    marginTop: 15,
    marginBottom: 10,
  },
  headerSecondLine: {
    height: 15,
  },
  headerContainer: {
    marginBottom: 18,
    marginHorizontal: 21,
  },
  titleContainer: {
    flex: 2,
    marginHorizontal: 8,
  },
  squareContianer: { flex: 1, width: 96 },
  titleFirstLine: {
    height: 12,
    marginTop: 8,
  },
  titleSecondLine: isFirstTitle => ({
    height: isFirstTitle ? 24 : 16,
    marginBottom: 16,
    marginTop: 8,
  }),
  footerSeparator: {
    height: 1,
    width: '100%',
    marginTop: 16,
  },
  footerButton: {
    height: 34,
    width: '100%',
    marginTop: 16,
    borderRadius: 5,
  },
  showMoreContainer: {
    marginBottom: 110,
    marginHorizontal: 21,
    alignItems: 'center',
  },
  showMore: {
    height: 16,
    width: 100,
  },
  showMoreLoadingContainer: {
    flexDirection: 'column',
  },
});
